// import 'babel-polyfill';
import 'objectFitPolyfill';

import './features/detect';
import './features/no-transition-on-resize';
import './features/inner-height-variable';

import './views/menu';
import './views/single-product';
import './views/single-product-more-products';
import './views/product-archive';
import './views/footer';
import './views/scroll-indicator';
import './views/retailer-documents';

import './view-initalizer';
